// extracted by mini-css-extract-plugin
export default {"memberContainer":"MemberAdditional_memberContainer__A13ob"};